import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../../../services/wrapper-http-service';
import { AllocationViewEndpoint } from '../../../constants';
import { Observable } from 'rxjs';
import { CombinedAttachmentsModel } from '../../../models/allocation-view-uli-item.model';
import { UliItemActionParams } from '../../models/uli-item-overview.model';
import { getQueryStringFromObject, Language } from '../../../../../../../common';
import { API_URL } from '../../../../../../../services/config';
import { HttpHeaders } from '@angular/common/http';
import { RequestHeader } from '../../../../../../constants/headers';

@Injectable({
  providedIn: 'root',
})
export class UliItemAttachmentsService {
  constructor(private http: WrapperHttpService) {}

  getUliAttachments({
    hubId,
    params: { uli, compartmentId, type },
    languageCode,
  }: {
    hubId: number;
    params: UliItemActionParams;
    languageCode: Language;
  }): Observable<CombinedAttachmentsModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Uli}/${uli}${
      AllocationViewEndpoint.Attachments
    }?${getQueryStringFromObject({
      hubId,
      compartmentId,
      type,
      languageCode,
    })}`;
    const headers = new HttpHeaders({ [RequestHeader.IntrackHubId]: hubId.toString() });

    return this.http.withLoading().get<CombinedAttachmentsModel>(url, { headers });
  }

  getPDF(imageId: string): Observable<string> {
    const picturePath = '/picture';
    const url = `${API_URL}${picturePath}?id=${imageId}`;

    return this.http.get(url, {
      responseType: 'text',
    });
  }
}
